import { KV } from '../common/Constant';
import qs from 'qs';
import 'formdata-polyfill';
import { b64EncodeUnicode, urljoin } from '../common/Utils';
import { systemProbe } from '../core/utils/util';

export default class Http {
  constructor(store) {
    this.store = store;
    this.e = {
      error: this._onError.bind(this),
      timeout: this._onTimeout.bind(this),
      onload: this._onLoad.bind(this),
      onLoadend: this._onLoadend.bind(this)
    };

    this.xhr = new XMLHttpRequest();
    // IE, 不支持赋值
    this.browserType = systemProbe().browser;
    if (this.browserType !== 'ie') {
      this.xhr.responseType = 'json';
      this.xhr.timeout = 5000;
    }
    this.xhr.onerror = this.e.error;
    this.xhr.ontimeout = this.e.timeout;
    this.xhr.onload = this.e.onload;
    this.xhr.onloadend = this.e.onLoadend;

    this.onError = null;
    this.onLoad = null;
    this.onLoadend = null;
    this.onTimeout = null;
  }

  /**
   * inner method
   *
   * @param {*} e
   * @memberof Http
   */
  _onError(e) {
    this.onError && this.onError(e.target.response);
    this.onError = null;
  }

  /**
   * inner method
   *
   * @param {*} e
   * @memberof Http
   */
  _onLoad(e) {
    if (!e.target) {
      this._onError(e);
      return;
    }

    let response = e.target.response;
    // IE, 由于未赋值responseType为JSON，故手动解析
    if (this.browserType === 'ie' && response && typeof response === 'string') {
      try {
        response = JSON.parse(response);
      } catch (error) {
        response = e.target.response;
      }
    }
    let { code, data } = response;
    if (+code !== 200) {
      this._onError(e);
      return;
    }

    this.onLoad && this.onLoad(data);
    this.onLoad = null;
  }

  /**
   * inner method
   *
   * @param {*} e
   * @memberof Http
   */
  _onLoadend(e) {
    this.onLoadend && this.onLoadend(e.target);
    this.onLoadend = null;
  }

  /**
   * inner method
   *
   * @param {*} e
   * @memberof Http
   */
  _onTimeout(e) {
    this.onTimeout && this.onTimeout(e.target);
    this.onTimeout = null;
  }

  /**
   * 发送请求
   *
   * @param {*} url API的URL
   * @param {*} data FormData
   * @param {string} [method='POST']
   * @memberof Http
   */
  fire(apiURL, data = {}, type = 'api', method = 'POST') {
    if (!this.xhr) {
      return;
    }
    let url = urljoin(process.env.API_SERVER, apiURL);

    const ua = navigator.userAgent;
    //ios终端
    const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    // uc 浏览器
    const ualower = navigator.userAgent.toLocaleLowerCase();
    const isuc = ualower.indexOf('ucbrowser') > -1;
    // 修复ios用UC浏览器观看直播点播时播放器初始化失败问题
    if (isiOS && isuc) {
      method = 'GET';
    }

    // 构建formData数据
    let formData = new FormData();
    formData.set(KV.CLIENT, this.store.getKV(KV.CLIENT));
    formData.set(KV.APP_ID, this.store.getKV(KV.APP_ID));
    formData.set(KV.THIRD_PARTY_USER_ID, this.store.getKV(KV.THIRD_PARTY_USER_ID));
    formData.set(KV.ACCESS_TOKEN, this.store.getKV(KV.ACCESS_TOKEN));
    formData.set(KV.PACKAGE_CHECK, this.store.getKV(KV.PACKAGE_CHECK));

    Object.keys(data).forEach(keys => {
      formData.set(keys, data[keys]);
    });

    if (method === 'POST') {
      this.xhr.open(method, url);
      this.xhr.send(formData);
    } else if (method === 'GET') {
      let obj = {};
      formData.forEach((value, key) => {
        obj[key] = value;
      });
      url += `?${qs.stringify(obj)}`;
      this.xhr.open(method, url);
      this.xhr.send();
    }
  }

  /**
   * HTTP模块销毁
   *
   * @memberof Http
   */
  destroy() {
    if (!this.xhr) {
      return;
    }

    this.xhr.onerror = null;
    this.xhr.onload = null;
    this.xhr.onloadend = null;
    this.xhr.ontimeout = null;
    this.xhr = null;

    this.onLoad = null;
    this.onLoadend = null;
    this.onTimeout = null;
    this.onError = null;
  }
}
